import { Autocomplete, Checkbox, Divider, Grid, TextField, Typography } from '@mui/material'
import contactStyle from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import React, { useContext, useEffect, useState } from 'react'
import Required from '../../../../../components/utility/required';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { currentActiveChatbotThreadTypeNew, manualAgentData, organizationUserDataModel } from '../../../../../models/axiosModel';
import GlobalButton from '../../../../../components/utility/globalButton/button';
import { getUserFullName, isWaSmbUser } from '../../../../../utils/constants';
import { useShallow } from 'zustand/react/shallow';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { renderAgentOption } from '../../../renderUtils';

interface setFlagAssignAgentPopupProps {
    handleToggleManualOverride: (user_assignment_id: string, flag_delete_agent: boolean, flag_send_agent_activity_message: boolean) => void,
    flagSendAgentActivityMsg: boolean
}

const AssignAgentPopup: React.FC<setFlagAssignAgentPopupProps> = (props) => { 

  const { currentActiveChatbotThread, setFlagAssignAgentPopup } = useRuleBasedInboxStore(useShallow((state) => ({
    currentActiveChatbotThread: state.currentActiveChatbotThread as currentActiveChatbotThreadTypeNew,
    setFlagAssignAgentPopup: state.setFlagAssignAgentPopup,
  })))

  // Destructure function props
  const { handleToggleManualOverride, flagSendAgentActivityMsg } = props;
  const { organizationDetails } = useContext(UserContext) as UserContextPayload; 

  const [selectedAgent, setSelectedAgent] = useState<organizationUserDataModel | manualAgentData | null>(null);
  const [agentOptionsData, setAgentOptionsData] = useState<organizationUserDataModel[]>(organizationDetails?.[0].organization_user_data?.filter((user) => !isWaSmbUser(user?.private_user_email)) ?? []);

  const [flagSendMsg, setFlagSendMsg] = useState<boolean>(flagSendAgentActivityMsg);

  const onChangeAgent = (value: organizationUserDataModel | null) => {
    setSelectedAgent(value);
  } 

  const handleAgentAction = () => {
    if(selectedAgent){
        handleToggleManualOverride(String(selectedAgent.user_assignment_id), false, flagSendMsg);
        setFlagAssignAgentPopup(false);
    }
  }

  useEffect(() => {
    if(currentActiveChatbotThread && currentActiveChatbotThread?.manual_agent_data){
        const agentAlreadyAssigned = currentActiveChatbotThread?.manual_agent_data?.some((agent) => !isWaSmbUser(agent?.private_user_first_name));
        if(agentAlreadyAssigned){
            setFlagAssignAgentPopup(false); // Close the popup if an agent is already assigned.
        }
    }
  }, [currentActiveChatbotThread])

  return (
    <>
      <Grid container>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={contactStyle.popupTitleTypography}>
                            Assign Agent
                        </Typography>
                    </Grid>

                    <Divider className={contactStyle.popupTitleDivider} /> 

                    <Grid item>
                        <Grid container className={contactStyle.popupBodyGridContainer} gap={1}>

                            <Grid item xs={12}>
                                <Grid container gap={"12px"}>
                                    <Grid item xs={12}>
                                        <Typography className={contactStyle.popupFieldTypography}> Agent <Required /> </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Autocomplete 
                                            className={`${contactStyle.contactFilterDropDowns} ${contactStyle.contactFilterDropdownsInPopup}`}
                                            options={agentOptionsData} 
                                            renderOption={(props, option) => renderAgentOption(props, option, option.private_user_id)}
                                            getOptionLabel={(option) => getUserFullName(option)} 
                                            value={selectedAgent as organizationUserDataModel | null}
                                            onChange={(e, newValue) => onChangeAgent(newValue)}
                                            renderInput={(params) => <TextField {...params} placeholder="Select Agent" />}
                                            ListboxProps={{
                                                className: styles.autocompleteListbox,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {flagSendAgentActivityMsg && 
                                <Grid item className={globalStyles.deleteConfirmPopupSubTextStyle} xs={12}>
                                    <Grid container className={globalStyles.displayFlex}>
                                        <Grid item>
                                            <Checkbox
                                                className={styles.sendAgentActivityConfirmationCheckbox} 
                                                disableRipple 
                                                checked={flagSendMsg}
                                                onChange={(event) => { setFlagSendMsg(event.target.checked) }} 
                                            />
                                        </Grid>
                                        <Grid item className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontSize} ${globalStyles.displayFlex}`}>
                                            Send Agent Activity Message
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }

                        </Grid> 
                    </Grid>

                     <Grid item>
                        <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} className={styles.assignAgentContainer}>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Cancel"
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    className='borderedButtonStyle'
                                    onClick={() => { setSelectedAgent(null); setFlagAssignAgentPopup(false); }}
                                >
                                </GlobalButton>
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Assign"
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    className='primaryButtonStyle'
                                    disabled={selectedAgent == null}
                                    onClick={() => { handleAgentAction();  }}
                                >
                                </GlobalButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </>
  )
}

export default AssignAgentPopup
